module.exports = __webpack_public_path__ + "img/hiring-img.a28a92e0.svg";